import { isPlatformServer } from '@angular/common';
import { Component, effect, inject, PLATFORM_ID } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';
import { catchError, map, of, switchMap } from 'rxjs';
import { buildPageTitle } from '../../../shared/constants/site-meta';
import { BlogsService } from '../../../shared/services/blogs.service';
import { MarketingBlogCardComponent } from '../../components/marketing-blog-card.component';
import { MarketingFooterComponent } from '../../components/marketing-footer.component';
import { MarketingHeaderComponent } from '../../components/marketing-header.component';
import { MarketingSectionHeadingComponent } from '../../components/marketing-section-heading.component';

@Component({
  selector: 'app-marketing-blogs-country-page',
  standalone: true,
  imports: [
    RouterLink,
    MarketingHeaderComponent,
    MarketingSectionHeadingComponent,
    MarketingBlogCardComponent,
    MarketingFooterComponent,
  ],
  templateUrl: './blogs-country-page.component.html',
})
export class MarketingBlogsCountryPageComponent {
  private readonly route = inject(ActivatedRoute);
  private readonly blogs = inject(BlogsService);
  private readonly title = inject(Title);
  private readonly meta = inject(Meta);
  private readonly platformId = inject(PLATFORM_ID);

  readonly pageState = toSignal(
    this.route.paramMap.pipe(
      switchMap((params) => {
        const slug = params.get('slug');
        if (!slug) return of({ kind: 'error' as const });
        return this.blogs.getPublicCountryListing(slug).pipe(
          map((page) => ({ kind: 'ok' as const, page })),
          catchError(() =>
            isPlatformServer(this.platformId)
              ? of({ kind: 'pending' as const })
              : of({ kind: 'error' as const }),
          ),
        );
      }),
    ),
    { initialValue: { kind: 'pending' as const } },
  );

  constructor() {
    effect(() => {
      const s = this.pageState();
      if (s.kind === 'ok') {
        this.title.setTitle(buildPageTitle(s.page.seo.title));
        this.meta.updateTag({ name: 'description', content: s.page.seo.description });
      }
    });
  }
}
